<template>
    <v-card class="elevation-1">
        <v-toolbar flat color="grey lighten-4 pt-1">
            <v-toolbar-title class="pl-3 grey--text text--darken-4">{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field class="hidden-xs-only"
                append-icon="search"
                label="Cerca"
                v-model="search"
            ></v-text-field>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container fluid py-0>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field class="hidden-sm-and-up"
                        append-icon="search"
                        label="Cerca"
                        v-model="search"
                        clearable
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-container>

        <v-data-table v-if="infoData.modelDef"
            :pagination.sync="pagination"
            :headers="fieldDefs"
            :items="items"
            :loading="loading"
            :search="search"
            v-model="selected"
            :rows-per-page-items="[10, 25, 50,  { text: 'Tutti', value: -1 }]"
            select-all
            >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th style="width: 50px">
                        <v-checkbox
                            color="primary"
                            @click.native="toggleAll"
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            hide-details
                        ></v-checkbox>
                    </th>
                    <th 
                        v-for="header in props.headers" 
                        :key="header.text"
                        :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                        @click="changeSort(header)">
                        <v-tooltip bottom>
                            <span slot="activator">
                                {{ header.text }}
                            </span>
                            <span>
                                {{ header.text }}
                            </span>
                        </v-tooltip>
                        <v-icon>arrow_upward</v-icon>
                    </th>
                </tr>
            </template>

            <template slot="items" slot-scope="props">
                <tr class="cursor-pointer">
                    <td>
                        <v-checkbox
                            color="primary"
                            v-model="props.selected"
                            hide-details
                        ></v-checkbox>
                    </td>
                    <template v-for="(header, h) in fieldDefs">
                        <td v-if="typeof header.text_value !== 'undefined'"
                            @click="openEdit(props.item)"
                            :key="h">
                            {{ props.item[header.text_value] }}
                        </td>
                        <td v-else
                            @click="openEdit(props.item)"
                            :key="h">
                            {{ props.item[header.value] }}
                        </td>
                    </template>
                </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                <div class="primary--text"><span class="primary--text">{{ countSelected }}</span> Selezionati</div>
                Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
            </template>
        </v-data-table>

        <v-card-text style="position: relative">
            <slot name="actions">
                <v-speed-dial
                    v-model="fab"
                    :fixed="actionPositionFixed"
                    :absolute="actionPositionAbsolute"
                    bottom
                    :left="positionLeft"
                    :right="positionRight"
                    :direction="direction"
                    transition="scale-transition">
                    <v-btn
                        slot="activator"
                        color="primary"
                        dark
                        fab
                        v-model="fab">
                        <v-icon>{{ actionIcon }}</v-icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-tooltip top>
                        <v-btn
                            fab
                            dark
                            small
                            color="indigo"
                            slot="activator"
                            @click.native.stop="showDialog = true">
                            <v-icon>add</v-icon>
                        </v-btn>
                        <span>Nuovo</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn
                            fab
                            dark
                            small
                            color="red"
                            slot="activator"
                            :disabled="disabled"
                            @click.native.stop="confirmDelete = true">
                            <v-icon>delete</v-icon>
                        </v-btn>
                        <span>Elimina</span>
                    </v-tooltip>
                </v-speed-dial>
            </slot>
        </v-card-text>

        <confirm-dialog
            :confirm="confirmDelete"
            mainTitle="Eliminare gli elementi selezionati?"
            secondTitle="Gli elementi selezionati verranno eliminati solamente se indipendenti e non collegati a nessun altra entità. Una volta eliminati non sarà possibile ripristinarli"
            @update:confirm="confirmDelete = false"
            :atConfirm="deleteModels"
        ></confirm-dialog>

        <v-dialog v-model="showDialog"
            max-width="800px"
            persistent lazy
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar flat color="grey lighten-4">
                    <v-toolbar-title class="pl-3 grey--text text--darken-4">
                        {{ title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container fluid pa-2>
                        <fields-generator
                            :layoutClass="['row','wrap']" 
                            :fields.sync="fieldsset"
                            :model="model"
                            ref="fieldsgenerator"
                            type="create"
                        ></fields-generator>
                        <small class="pl-4">* Indica i campi obbligatori</small>
                    </v-container>
                </v-card-text>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native.stop="closeDialog()">Chiudi</v-btn>
                    <v-btn color="primary" flat @click.native="storeModel()">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>
</template>

<script>
import FieldsGenerator from '@/components/FieldsGenerator'
import DataTableMixin from '@/mixins/DataTableMixin.js'

export default {
	name: 'general-types-crud',
	components: {
		FieldsGenerator
	},
	mixins: [DataTableMixin],
	props: {
		title: String,
		actionIcon: String,
		modelDef: String,
		subFilters: Object,
		actionPosition: String,
		defaultInput: Object,
		redirect: Object,
		speedDialOptions: Object,
		positionRight: {
			type: Boolean,
			default: true
		},
		positionLeft: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: 'left'
		}
	},

	data() {
		return {
			confirmDelete: false,
			disabled: true,
			fab: false,
			infoData: {},
			showDialog: false,
			selected: [],
			search: '',
			items: [],
			loading: 'primary',
			pagination: {},
			totalItems: 0,
			fieldsset: {},
			model: {}
		}
	},

	mounted() {
		this.$eventBusUtility.$on('refreshTable', modelDef => {
			this.getDataFromApi()
		})
	},

	methods: {
		getDataFromApi() {
			this.loading = 'primary'

			this.axios.post('generaltypes-filters', this.subFilters).then(response => {
				// get body data
				this.loading = false
				this.items = response.data.data.data
				this.totalItems = this.items.length
			},
			response => {
				// error callback
				this.loading = false
			})
		},

		openEdit(item) {
			this.model = Object.assign(this.model, item)
			this.loading = false
			this.showDialog = true
		},

		storeModel() {
			this.$refs.fieldsgenerator.$validator
				.validateAll()
				.then(result => {
					if (!result) {
						return false
					}

					let urlWithAppend =            this.subFilters.key != '' ? '/' + this.subFilters.key : ''
					if (_.has(this.model, 'id')) {
						this.axios
							.put('generaltypes' + urlWithAppend + '/' + this.model.id,
								this.model)
							.then(response => {
								// get body data
								this.getDataFromApi()
								this.closeDialog()

								// Got in show
							},
							response => {
								// error callback
							})
					} else {
						this.axios
							.post('generaltypes' + urlWithAppend + '/', this.model)
							.then(response => {
								// get body data
								this.getDataFromApi()
								this.closeDialog()
								// Got in show
							},
							response => {
								// error callback
							})
					}
				})
				.catch(() => {})
		},

		closeDialog() {
			this.showDialog = false
			this.model = {}
		}
	},

	created() {
		// Get info data for model
		this.axios.get(this.modelDef + '-info/' + this.subFilters.key).then(response => {
			// get info data
			this.infoData = response.data.info
			this.fieldsset = response.data.fields
			this.getDataFromApi()
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
			this.loading = false
		})
	}
}
</script>
<style scoped>
.priority {
  border-radius: 3px;
  padding: 4px;
  font-weight: 500 !important;
  color: white;
  max-width: 95px;
  text-align: center;
}
</style>
